var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import classNames from "classnames";
import { QuiSpinner } from "../QuiSpinner/QuiSpinner.js";
import { fieldSizeToIconSize, WithIcon } from "../_primitives/WithIcon.js";
export var QuiButtonVariantEnum;
(function (QuiButtonVariantEnum) {
    QuiButtonVariantEnum["Default"] = "default";
    QuiButtonVariantEnum["Destructive"] = "destructive";
    QuiButtonVariantEnum["Primary"] = "primary";
    QuiButtonVariantEnum["Green"] = "green";
    QuiButtonVariantEnum["Minimal"] = "minimal";
    QuiButtonVariantEnum["BrandGradient"] = "brand-gradient";
    QuiButtonVariantEnum["BrandPurple"] = "brand-purple";
    QuiButtonVariantEnum["Black"] = "black";
    QuiButtonVariantEnum["Gold"] = "gold";
    QuiButtonVariantEnum["Teal"] = "brand-teal";
    QuiButtonVariantEnum["Outline"] = "outline";
    QuiButtonVariantEnum["OutlineGreen"] = "outline-green";
    QuiButtonVariantEnum["OutlineBlue"] = "outline-blue";
    QuiButtonVariantEnum["OutlineRed"] = "outline-red";
    QuiButtonVariantEnum["OutlineBlack"] = "outline-black";
    QuiButtonVariantEnum["OutlinePurple"] = "outline-purple";
})(QuiButtonVariantEnum || (QuiButtonVariantEnum = {}));
export const QuiButton = forwardRef((_a, ref) => {
    var { iconLeft, iconRight, active, children, variant, size, onClick, disabled, spinner, className } = _a, otherProps = __rest(_a, ["iconLeft", "iconRight", "active", "children", "variant", "size", "onClick", "disabled", "spinner", "className"]);
    const iconProps = {
        iconLeft,
        iconRight,
        iconSize: fieldSizeToIconSize(size),
    };
    const displayAsDisabled = disabled === true || spinner === true;
    const buttonClassName = getButtonClassName({
        variant,
        size,
        children,
        iconLeft,
        iconRight,
        className,
        active,
        disabled: displayAsDisabled,
        spinner,
    });
    return (React.createElement("button", Object.assign({ ref: ref, className: buttonClassName, disabled: displayAsDisabled, onClick: (e) => !displayAsDisabled && onClick && onClick(e) }, otherProps),
        spinner && (React.createElement("div", { className: "qui-button-spinner", style: { position: "absolute" } },
            React.createElement(QuiSpinner, { size: size !== null && size !== void 0 ? size : "md" }))),
        React.createElement("div", { className: "qui-button-contents" },
            React.createElement(WithIcon, Object.assign({}, iconProps), children))));
});
QuiButton.displayName = "QuiButton";
export function getButtonClassName(config) {
    const { variant, size, children, iconRight, iconLeft, active, disabled, className, spinner } = config;
    const variantPrefix = variant && variant !== "default" ? `-${variant}` : "";
    const sizePrefix = size && size !== "md" ? `-${size}` : "";
    const onlyHasOneIcon = !children && (iconRight || iconLeft) && !(iconRight && iconLeft);
    return classNames(`qui-button${variantPrefix}${sizePrefix}`, {
        "qui-button-state-spinning": spinner,
        "qui-button-state-active": active,
        "qui-disabled": disabled,
        [`qui-button${sizePrefix}-single-icon-only`]: onlyHasOneIcon,
    }, className);
}
